import introStepIcon1 from './images/intro-step-icon-1.svg';
import introStepIcon2 from './images/intro-step-icon-2.svg';
import introStepIcon3 from './images/intro-step-icon-3.svg';

import benefitsIcon1 from './images/benefits-icon-1.svg';
import benefitsIcon2 from './images/benefits-icon-2.svg';
import benefitsIcon3 from './images/benefits-icon-3.svg';
import benefitsIcon4 from './images/benefits-icon-4.svg';

export const introSteps = [
  {
    icon: introStepIcon1,
    text: 'Start from web or mobile',
  },
  {
    icon: introStepIcon2,
    text: 'Take 2 photos',
  },
  {
    icon: introStepIcon3,
    text: 'Get recommendations on all devices',
  },
];

export const benefits = [
  {
    icon: benefitsIcon1,
    text: 'Returns decrease',
  },
  {
    icon: benefitsIcon2,
    text: 'Loyalty and retention',
  },
  {
    icon: benefitsIcon3,
    text: 'Increase in conversions',
  },
  {
    icon: benefitsIcon4,
    text: 'Happy customers',
  },
];

export const howWorks = [
  {
    title: 'Take 2 photos',
    text: 'Users simply take a photo of each foot, all takes less than 30 seconds',
  },
  {
    title: 'Analyze',
    text: 'FootScanner™ Neural Network analyzes the image, considering foot size, shape, and various other factors',
  },
  {
    title: 'Report',
    text: 'Our system provides measurements for foot length and width, along with shoe size and fit recommendations',
  },
  {
    title: 'Recommended sizes',
    text: 'FootScanner™ seamlessly uploads the recommended size to product pages for all types of footwear',
  },
];
